// cibil.js
import React, { useState } from 'react';
import './Cibil.css';

const Cibil = () => {
  const [formData, setFormData] = useState({
    gender: 'Male',
    fullName: '',
    dateOfBirth: '',
    mobileNumber: '',
    emailAddress: '',
    city: '',
    address: '',
    pinCode: '',
    pan: '',
    agreeTerms: false
  });

  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.agreeTerms) {
      alert('Please agree to the terms and conditions');
      return;
    }
    console.log('Form submitted:', formData);
    alert('Thank you! Your credit report request has been submitted. You will receive it on your email soon.');
  };

  const handleFaqClick = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const faqData = [
    {
      q: "How can I get my full CIBIL report free?",
      a: "You can get your full CIBIL report free once a year from CIBIL's official website or through RBI-approved credit bureaus. Many banks and financial institutions also offer free credit reports to their customers."
    },
    {
      q: "What is the best way to check CIBIL score?",
      a: "The best way is to check directly through CIBIL's official website or mobile app. You can also check through your bank's net banking portal if they provide this service, as these are secure and reliable sources."
    },
    {
      q: "Are there any charges to check CIBIL score?",
      a: "You can check your CIBIL score once a year for free. For more frequent checks, CIBIL offers paid subscription plans. Some banks and financial apps also provide free credit score checks to their customers."
    },
    {
      q: "How can I increase my CIBIL score to 800?",
      a: "To increase your CIBIL score to 800: pay all EMIs and credit card bills on time, keep credit utilization below 30%, maintain a healthy mix of credit, avoid too many loan inquiries, and regularly monitor your credit report for errors."
    },
    {
      q: "Is 800 a good CIBIL score?",
      a: "Yes, 800 is an excellent CIBIL score. It indicates strong creditworthiness and responsible financial behavior. With this score, you're likely to get quick loan approvals, lower interest rates, and better credit card offers."
    },
    {
      q: "How can I get a 900 CIBIL score?",
      a: "While 900 is the maximum CIBIL score, it's extremely rare. To aim for it: maintain a flawless payment history for 7+ years, keep credit utilization below 10%, have a perfect mix of secured/unsecured loans, and maintain long credit relationships."
    }
  ];

  return (
    <div className="cibil-page">
      <div className="cibil-two-column-container">
        {/* LEFT - Promotional side with new gauge image */}
        <div className="cibil-left-panel">
          <div className="cibil-promo-content">
            <h1 className="cibil-promo-title">
              Check Your <span className="cibil-highlight">Cibil Credit Report</span><br />
              in Just a Few Simple Steps
            </h1>

            <div className="cibil-speedometer-wrapper">
              <img 
                src="/images/speedo4.jpg" 
                alt="Credit Score Gauge" 
                className="cibil-speedometer-image" 
              />
            </div>

            <p className="cibil-promo-subtitle">
              Get unlimited access to your credit report dashboard. View your score, monitor changes, and explore personalized loan options — all in one secure place.
            </p>

            <ul className="cibil-benefits-list">
              <li>Secure digital document submission to banks & NBFCs</li>
              <li>Personalized loan & credit card offers</li>
              <li>Multiple banking partners available</li>
              <li>No impact on your credit score</li>
              <li>No hard inquiry recorded</li>
            </ul>
          </div>
        </div>

        {/* RIGHT - Form side */}
        <div className="cibil-right-panel">
          <div className="cibil-form-panel">
            <h2 className="cibil-form-title">
              Get Your Free Cibil Credit Report
            </h2>
            <p className="cibil-form-subtitle">Enter your details below — your report will be sent securely to your email.</p>

            <form onSubmit={handleSubmit} className="cibil-form">
              
              <div className="cibil-form-row">
                <input type="text" name="fullName" placeholder="Full Name*" required value={formData.fullName} onChange={handleChange} />
                <input type="text" name="pan" placeholder="PAN Number*" maxLength={10} style={{ textTransform: 'uppercase' }} required value={formData.pan} onChange={handleChange} />
              </div>

              <div className="cibil-form-row">
                <input type="date" name="dateOfBirth" required value={formData.dateOfBirth} onChange={handleChange} />
                <input type="email" name="emailAddress" placeholder="Email Address*" required value={formData.emailAddress} onChange={handleChange} />
              </div>

              <div className="cibil-form-row">
                <input type="tel" name="mobileNumber" placeholder="Mobile Number*" maxLength={10} required value={formData.mobileNumber} onChange={handleChange} />
                <input type="text" name="pinCode" placeholder="PIN Code*" maxLength={6} required value={formData.pinCode} onChange={handleChange} />
              </div>

              <div className="cibil-form-row">
                <input type="text" name="city" placeholder="City*" required value={formData.city} onChange={handleChange} />
                <input type="text" name="address" placeholder="Full Address*" required value={formData.address} onChange={handleChange} />
              </div>

              <div className="cibil-terms-group">
                <label className="cibil-terms-label">
                  <input type="checkbox" name="agreeTerms" checked={formData.agreeTerms} onChange={handleChange} />
                  <span>I agree to the <a href="#">Terms of Use</a>, <a href="#">Privacy Policy</a>, and authorize the processing of my credit information.</span>
                </label>
              </div>

              <button type="submit" className="cibil-submit-button">
                Get My Credit Report
              </button>
            </form>
          </div>
          
          {/* FAQ section */}
          <div className="cibil-faq-section">
            <h3 className="cibil-faq-title">Why should I check credit report?</h3>
            <ul className="cibil-faq-list">
              <li>Checking your credit scores and reports can help you better understand your current credit position.</li>
              <li>Credit scores are used by potential lenders and creditors as one factor when deciding whether to offer you credit, like a loan or a credit card.</li>
              <li>Checking your own credit scores and reports will not impact your credit scores.</li>
            </ul>
          </div>
        </div>
      </div>

      {/* NEW SECTION: CIBIL Score Information */}
      <div className="cibil-score-info-section">
        <h2 className="cibil-score-info-title">What is a CIBIL Score?</h2>
        <p className="cibil-score-info-description">
          A CIBIL Score is a three-digit numerical score, ranging from 300 to 900, that represents an individual's creditworthiness. It is calculated by TransUnion CIBIL, based on a person's credit history, including loan repayment behavior, credit card usage, outstanding debts, and length of credit history.
          <br /><br />
          A higher CIBIL Score indicates responsible credit behavior and improves the chances of loan or credit card approval at better interest rates, while a lower score may lead to rejection or higher interest rates.
        </p>
        
        <div className="cibil-score-table-container">
          <table className="cibil-score-table">
            <thead>
              <tr>
                <th>Score Range</th>
                <th>Meaning</th>
                <th>Loan Approval Chances</th>
              </tr>
            </thead>
            <tbody>
              <tr className="cibil-score-excellent">
                <td>750 – 900</td>
                <td>Excellent</td>
                <td>Very High</td>
              </tr>
              <tr className="cibil-score-good">
                <td>700 – 749</td>
                <td>Good</td>
                <td>High</td>
              </tr>
              <tr className="cibil-score-fair">
                <td>650 – 699</td>
                <td>Fair</td>
                <td>Possible but with higher rates</td>
              </tr>
              <tr className="cibil-score-poor">
                <td>550 – 649</td>
                <td>Poor</td>
                <td>Low</td>
              </tr>
              <tr className="cibil-score-very-poor">
                <td>300 – 549</td>
                <td>Very Poor</td>
                <td>Very Low</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* How to Check Credit Score Section */}
        <div className="cibil-check-guide-container">
          <h2 className="cibil-check-guide-title">How to Do a CREDIT Score Check Online – Step-by-Step</h2>
          <p className="cibil-check-guide-subtitle">Checking your score is easy and free. Just follow these steps:</p>
          
          <div className="cibil-steps-container">
            <div className="cibil-step">
              <div className="cibil-step-number">1</div>
              <div className="cibil-step-content">
                <h3 className="cibil-step-title">Go to the Credit Score Check Page</h3>
                <p className="cibil-step-description">Click on the "Check Credit Score" button on our website.</p>
              </div>
            </div>
            
            <div className="cibil-step">
              <div className="cibil-step-number">2</div>
              <div className="cibil-step-content">
                <h3 className="cibil-step-title">Enter Your Basic Details</h3>
                <p className="cibil-step-description">Fill in your name, date of birth, PAN card number, and contact details.</p>
              </div>
            </div>
            
            <div className="cibil-step">
              <div className="cibil-step-number">3</div>
              <div className="cibil-step-content">
                <h3 className="cibil-step-title">Verify Your Identity</h3>
                <p className="cibil-step-description">An OTP will be sent to your registered mobile number or email.</p>
              </div>
            </div>
            
            <div className="cibil-step">
              <div className="cibil-step-number">4</div>
              <div className="cibil-step-content">
                <h3 className="cibil-step-title">Get Your Credit Score Instantly</h3>
                <p className="cibil-step-description">Your CREDIT score and report will be displayed on your screen within seconds.</p>
              </div>
            </div>
          </div>
          
          <div className="cibil-pro-tip">
            <h4 className="cibil-pro-tip-title">Pro Tip for Loan Agents & DSAs</h4>
            <p className="cibil-pro-tip-text">Use this step to pre-qualify customers, saving time and increasing conversion rates.</p>
          </div>
        </div>

        {/* How is CIBIL Score Calculated Section */}
        <div className="cibil-calculation-container">
          <h2 className="cibil-calculation-title">How Is CIBIL Score Calculated?</h2>
          <p className="cibil-calculation-subtitle">Following is the expected calculation process of the CIBIL Score:</p>
          
          <div className="cibil-calculation-content">
            <div className="cibil-calculation-item">
              <h3 className="cibil-calculation-item-title">Payment History</h3>
              <p className="cibil-calculation-item-text">
                This is the most significant factor and includes your track record of paying off credit card bills and loan EMIs. Timely payments improve your score, while missed or late payments can harm it. Your payment history can influence approximately <strong>30% to 35%</strong> of your CIBIL Score result.
              </p>
            </div>
            
            <div className="cibil-calculation-item">
              <h3 className="cibil-calculation-item-title">Credit Utilisation Ratio</h3>
              <p className="cibil-calculation-item-text">
                This measures how much credit you've used compared to your available credit limit. A lower utilisation rate benefits your score because it signals to the credit bureau that you maintain a healthy financial lifestyle. Your Credit Utilisation Ratio can impact approximately <strong>25% to 30%</strong> of your CIBIL Score outcome.
              </p>
            </div>
            
            <div className="cibil-calculation-item">
              <h3 className="cibil-calculation-item-title">Credit Type and Duration</h3>
              <p className="cibil-calculation-item-text">
                Having a mix of credit types (secured and unsecured loans) and a long credit history can positively affect your score. This enables you to showcase to a credit bureau company that you are good at managing multiple credit options and have good repayment behaviour. This section can influence about <strong>25%</strong> of your CIBIL Score result.
              </p>
            </div>
            
            <div className="cibil-calculation-item">
              <h3 className="cibil-calculation-item-title">Other Factors</h3>
              <p className="cibil-calculation-item-text">
                These refer to other minor factors that can affect your CIBIL Score. These can include the number of credit inquiries made, your outstanding loan amount, whether any discrepancy occurs, etc. However, this section can influence only <strong>10% to 20%</strong> of your CIBIL Score result, making it less significant than others.
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Accordion Section */}
        <div className="cibil-faq-accordion-container">
          <h2 className="cibil-faq-accordion-main-title">Frequently Asked Questions</h2>
          
          <div className="cibil-faq-accordion">
            {faqData.map((faq, index) => (
              <div 
                key={index} 
                className={`cibil-faq-accordion-item ${openFaqIndex === index ? 'cibil-active' : ''}`}
              >
                <button 
                  className="cibil-faq-accordion-question"
                  onClick={() => handleFaqClick(index)}
                >
                  <span>{faq.q}</span>
                  <span className="cibil-faq-accordion-icon">
                    {openFaqIndex === index ? '▲' : '▼'}
                  </span>
                </button>
                <div className="cibil-faq-accordion-answer">
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cibil;